module.exports = __webpack_public_path__ + "static/media/BannerTarjeta_Planeta.8afae7a7.png";